var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currentOrg)?_c('router-view',{attrs:{"currentOrg":_vm.currentOrg}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }